import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

export default function useI18n() {
  const {
    t,
    i18n: { changeLanguage, language: currentLanguage },
  } = useTranslation()

  const numberFormatter = useMemo(
    () =>
      new Intl.NumberFormat(currentLanguage, {
        maximumFractionDigits: 4,
      }).format,
    [currentLanguage]
  )

  const numberFormatter2Decimals = useMemo(
    () =>
      new Intl.NumberFormat(currentLanguage, {
        maximumFractionDigits: 2,
      }).format,
    [currentLanguage]
  )

  const dateFormatter = useMemo(
    () =>
      new Intl.DateTimeFormat(currentLanguage, {
        month: 'long',
        year: 'numeric',
        day: 'numeric',
      }).format,
    [currentLanguage]
  )

  const shortDateFormatter = useMemo(
    () =>
      new Intl.DateTimeFormat(currentLanguage, {
        month: 'numeric',
        day: 'numeric',
        year: 'numeric',
      }).format,
    [currentLanguage]
  )

  const shortDateFormatterUtc = useMemo(
    () =>
      new Intl.DateTimeFormat(currentLanguage, {
        month: 'numeric',
        day: 'numeric',
        year: 'numeric',
        timeZone: 'UTC',
      }).format,
    [currentLanguage]
  )

  const currencyFormatter = useMemo(
    () =>
      new Intl.NumberFormat(currentLanguage, {
        style: 'currency',
        currency: 'EUR',
        maximumFractionDigits: 0,
      }).format,
    [currentLanguage]
  )

  const currencyFormatter2Decimals = useMemo(
    () =>
      new Intl.NumberFormat(currentLanguage, {
        style: 'currency',
        currency: 'EUR',
        maximumFractionDigits: 2,
      }).format,
    [currentLanguage]
  )

  const currencyFormatterWith3Decimal = useMemo(
    () =>
      new Intl.NumberFormat(currentLanguage, {
        style: 'currency',
        currency: 'EUR',
        maximumFractionDigits: 3,
      }).format,
    [currentLanguage]
  )

  const numberFormatterNoDecimals = useMemo(
    () =>
      new Intl.NumberFormat(currentLanguage, {
        maximumFractionDigits: 0,
      }).format,
    [currentLanguage]
  )

  return {
    t,
    currentLanguage,
    handleChangeLanguage: changeLanguage,
    numberFormatter,
    numberFormatter2Decimals,
    dateFormatter,
    currencyFormatter,
    currencyFormatter2Decimals,
    currencyFormatterWith3Decimal,
    shortDateFormatter,
    shortDateFormatterUtc,
    numberFormatterNoDecimals,
  }
}
